import React, { useState } from 'react'
import OTPInput from 'react-otp-input';
import './Otp.css'

const Otp = ({ className , value,setValue  }) => {
    return (
        <OTPInput
            value={value}
            onChange={setValue}
            placeholder='0000'
            inputType='number'
            numInputs={4}
            // A box that holds a digit eases to the brand blue, so every
            // keystroke visibly lands. Colour only, 150ms ease-out. Marked
            // important because the global .otp_input rule (index.css) sets
            // the border and background after Tailwind's utilities.
            renderInput={(props) => <input {...props} className={`flex w-20 h-20 text-center text-[32px] not-italic font-semibold justify-center items-center gap-2.5 border px-4 py-3 rounded-[10px] border-solid transition-[border-color,background-color] duration-150 ease-out motion-reduce:transition-none ${props.value ? '!border-[#00A9E7] !bg-[#F4FBFE]' : 'border-[#DDE2E4] bg-white'} max767:w-[80px] max767:h-[80px] max-350:w-[55px] max-350:h-[55px] ${className} otp_input `} />}
        />
    )
}

export default Otp